/**
 * Header Component
 */

import './styles.scss';

import * as React from 'react';
import * as BEM from 'react-bem-helper';
import { connect, DispatchProp } from 'react-redux';
import { createFragmentContainer } from 'react-relay';

import { HeaderFragment } from '../../../../relay/header';

import HeaderPosts from '../../content/HeaderPosts';
import { AppNavigation } from '../AppNavigation';
import { BrandNavigation } from '../BrandNavigation';

interface IOwnStateProps {
  itemsInCart: number;
  isUserLoggedIn: boolean;
}

interface IOwnProps {
  viewer: GQL.IViewer;
  type: HeaderType;
  cartInfo: GQL.ICart | null;
  userProfile: GQL.IProfile | null;
}

export type ExtendedHeaderProps = IOwnProps;

type HeaderProps = IOwnProps & IOwnStateProps & Required<DispatchProp<any>>;

const classes = new BEM('app-header');

function Header(props: HeaderProps) {
  const {
    cartInfo,
    type,
    userProfile,
    viewer,
  } = props;

  return (
    <>
      <div {...classes('fixed-guard', { [type]: !!type })} />
      <div {...classes('', { [type]: !!type })}>
        <div {...classes('upper-header')}>
          <BrandNavigation />
          {/* tslint:disable-next-line:max-line-length */}
          <HeaderPosts data={viewer! && viewer.home_page! && viewer.home_page!.header_posts!} />
        </div>
        <AppNavigation
          cartInfo={cartInfo}
          userProfile={userProfile}
          type={type}
        />
      </div>
    </>
  );
}

const ConnectedHeader = connect<IOwnStateProps, DispatchProp<any>, IOwnProps, IStoreState>(
  ({ cart, user }) => ({
    itemsInCart: !!cart && cart.lineItems.length,
    isUserLoggedIn: user.isLoggedIn,
  }),
  (dispatch) => ({ dispatch }),
)(Header);

const RelayHeader = createFragmentContainer(
  ConnectedHeader,
  HeaderFragment,
);

export default RelayHeader;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/organisms/global/Header/index.tsx